import { CatHeading } from '@blocks-react/components/Heading';
import { Conditional } from '../conditional';
import { StoreHoursInfoProps } from './types';
import styles from './store-hours-info.module.scss';
import cx from 'classnames';

export const StoreHoursInfo = ({
  title,
  open24HoursTitle,
  isStoreAvailable24Hrs,
  isStoreClosed,
  isStoreLocationOptimizationFlag,
  forStoreInfoDrawer,
  children
}: StoreHoursInfoProps) => {
  return (
    <Conditional test={!isStoreClosed}>
      <CatHeading
        level="h2"
        variant={'title-sm'}
        className={isStoreLocationOptimizationFlag ? 'my-2' : ''}
      >
        {title}
      </CatHeading>
      <Conditional test={isStoreAvailable24Hrs} fallback={children}>
        <p
          className={cx(
            styles['store-hours-info-text'],
            'exclude-global cat-u-theme-typography-body-sm'
          )}
        >
          {open24HoursTitle}
        </p>
      </Conditional>
    </Conditional>
  );
};
